import State from './state'
import { createSlice } from '@reduxjs/toolkit'

const adminBookingsReducer = createSlice({
  name: 'adminBookingsReducer',
  initialState: State,
  reducers: {
    setRecords: (state, action) => {
      state.data = action.payload
    }
  }
})

export default adminBookingsReducer
